import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import {Clock, Mail, MessageCircle, MessageSquare, Phone, Send, User, X} from "lucide-react";
const Modal = ({ isOpen, onClose, type }) => {
  const [showCallbackForm, setShowCallbackForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    onClose();
  };

  const handleCallbackSubmit = (e) => {
    e.preventDefault()
    console.log('Callback Data:', formData)
    setShowCallbackForm(false)
    onClose()
  }

  // Callback Form Modal
  if (showCallbackForm) {
    return (
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-40 bg-black bg-opacity-50 backdrop-blur-sm"
          onClick={() => setShowCallbackForm(false)}
        />
        
        <div className="flex fixed inset-0 z-50 justify-center items-center p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: "spring", bounce: 0.3 }}
            className="p-6 w-full max-w-md bg-white rounded-xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <button
                onClick={() => setShowCallbackForm(false)}
                className="absolute top-0 right-0 p-2 rounded-full transition-colors hover:bg-gray-100"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>

              <div className="mb-6 text-center">
                <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full">
                  <Clock className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Schedule a Callback</h3>
                <p className="mt-2 text-gray-600">Tell us when you'd like us to call</p>
              </div>

              <form onSubmit={handleCallbackSubmit} className="space-y-4">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Name</label>
                  <input
                    type="text"
                    className="px-4 py-2 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                  <input
                    type="tel"
                    className="px-4 py-2 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Preferred Time</label>
                  <select
                    className="px-4 py-2 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                    value={formData.preferredTime}
                    onChange={(e) => setFormData({...formData, preferredTime: e.target.value})}
                    required
                  >
                    <option value="">Select a time</option>
                    <option value="morning">Morning (8AM - 12PM)</option>
                    <option value="afternoon">Afternoon (12PM - 4PM)</option>
                    <option value="evening">Evening (4PM - 7PM)</option>
                  </select>
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Message (Optional)</label>
                  <textarea
                    className="px-4 py-2 w-full h-24 rounded-lg border border-gray-300 resize-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    placeholder="Tell us what you'd like to discuss"
                  />
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="flex justify-center items-center py-3 space-x-2 w-full font-medium text-white bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg shadow-lg shadow-purple-500/30"
                  type="submit"
                >
                  <Clock className="w-5 h-5" />
                  <span>Schedule Callback</span>
                </motion.button>
              </form>
            </div>
          </motion.div>
        </div>
      </AnimatePresence>
    )
  }

  // Original phone modal code
  if (type === 'phone') {
    return (
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-40 bg-black bg-opacity-50 backdrop-blur-sm"
              onClick={onClose}
            />
            
            <div className="flex fixed inset-0 z-50 justify-center items-center p-4">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ type: "spring", bounce: 0.3 }}
                className="relative p-8 w-full max-w-md bg-white rounded-xl shadow-2xl"
              >
                <button
                  onClick={onClose}
                  className="absolute top-4 right-4 p-2 rounded-full transition-colors hover:bg-gray-100"
                >
                  <X className="w-5 h-5 text-gray-500" />
                </button>

                <div className="space-y-6 text-center">
                  <div className="flex justify-center items-center mx-auto w-20 h-20 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full">
                    <Phone className="w-10 h-10 text-white" />
                  </div>
                  
                  <div className="space-y-2">
                    <h3 className="text-2xl font-bold text-gray-800">Call Support</h3>
                    <p className="text-gray-600">We're available Mon-Fri, 8am-7pm</p>
                  </div>

                  <motion.a
                    href="tel:+1234567890"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="block px-6 py-4 w-full text-xl font-semibold text-white bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl shadow-lg shadow-pink-500/30"
                  >
                    <div className="flex justify-center items-center space-x-3">
                      <Phone className="w-6 h-6" />
                      <span>+1 (234) 567-890</span>
                    </div>
                  </motion.a>

                  <div className="pt-4 space-y-4 border-t">
                    <p className="text-sm text-gray-600">
                      Alternatively, you can schedule a callback
                    </p>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => setShowCallbackForm(true)}
                      className="flex justify-center items-center px-6 py-3 space-x-2 w-full font-medium text-gray-700 rounded-xl border-2 border-gray-200 transition-colors hover:bg-gray-50"
                    >
                      <Clock className="w-5 h-5" />
                      <span>Schedule a Callback</span>
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    )
  }

  // Email modal
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={onClose}
          />
          
          <div className="flex fixed inset-0 z-50 justify-center items-center p-4">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ type: "spring", bounce: 0.3 }}
              className="relative p-8 w-full max-w-md bg-white rounded-xl shadow-2xl"
            >
              <button
                onClick={onClose}
                className="absolute top-4 right-4 p-2 rounded-full transition-colors hover:bg-gray-100"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>

              <div className="mb-8 space-y-6 text-center">
                <div className="flex justify-center items-center mx-auto w-20 h-20 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full">
                  <MessageSquare className="w-10 h-10 text-white" />
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-gray-800">Send us a Message</h3>
                  <p className="mt-2 text-gray-600">We'll get back to you within 1 hour</p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Full Name</label>
                  <div className="relative">
                    <input
                      type="text"
                      className="py-3 pr-4 pl-11 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      required
                    />
                    <User className="absolute left-3 top-1/2 w-5 h-5 text-gray-400 -translate-y-1/2" />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Email Address</label>
                  <div className="relative">
                    <input
                      type="email"
                      className="py-3 pr-4 pl-11 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      required
                    />
                    <Mail className="absolute left-3 top-1/2 w-5 h-5 text-gray-400 -translate-y-1/2" />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Message</label>
                  <div className="relative">
                    <textarea
                      className="py-3 pr-4 pl-11 w-full h-32 rounded-lg border border-gray-300 resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      required
                    />
                    <MessageCircle className="absolute left-3 top-4 w-5 h-5 text-gray-400" />
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="flex justify-center items-center py-3 space-x-2 w-full font-medium text-white bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg shadow-lg shadow-blue-500/30"
                  type="submit"
                >
                  <Send className="w-5 h-5" />
                  <span>Send Message</span>
                </motion.button>
              </form>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  )
}

export default Modal;